import { render, staticRenderFns } from "./AgreementProductRegistrationModal.vue?vue&type=template&id=60904c28&scoped=true&lang=pug&"
import script from "./AgreementProductRegistrationModal.vue?vue&type=script&lang=ts&"
export * from "./AgreementProductRegistrationModal.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementProductRegistrationModal.vue?vue&type=style&index=0&id=60904c28&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60904c28",
  null
  
)

export default component.exports